import { useState, useMemo, useRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import ArrowIcon from '../../../../assets/svg/button-right.svg?react';
import FJSideModel from '../../../../common/components/FJSideModel/FJSideModel';
import styles from './FJTextToImageStyles.module.less';
import FJHorizontalScrollTab from '../../../../common/components/FJTab/FJHorizontalScrollTab';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import classNames from 'classnames';

const FJTextToImageStyles = ({ curStyle, changeStyle, styleList, id }) => {
    const [showSideModel, setShowSideModel] = useState(false);
    const [selectStyleCategory, setSelectStyleCategory] = useState(-1);
    const scrollRef = useRef(null);
    const categoryRef = useRef([]);
    const _isScrollingRef = useRef(false);
    const _scrollingTimerRef = useRef(null);
    const tabRef = useRef(null);

    const handleClick = e => {
        e.stopPropagation();
        setShowSideModel(!showSideModel);
    };

    const handleOnMouseDown = e => {
        showSideModel && e.stopPropagation();
    };

    const categoryList = useMemo(() => {
        if (!styleList || !Array.isArray(styleList)) return [];

        const categoryList = styleList.map(item => ({ type: item.categoryName, text: item.categoryName }));

        const uniqueCategoryList = categoryList.filter(item => {
            return item.type !== 'no-style';
        });

        return uniqueCategoryList;
    }, [styleList]);

    const handleChangeStyle = useCallback(
        style => {
            changeStyle && changeStyle(style);
            setShowSideModel(false);
        },
        [changeStyle],
    );

    const _onTabChange = useCallback(
        idx => {
            setSelectStyleCategory(idx);
            if (!scrollRef.current || !categoryRef.current) return;
            const category = categoryRef.current[idx + 1];
            if (category) {
                const rect = category.getBoundingClientRect();
                const scrollDom = scrollRef.current.getScroller();
                const scrollRect = scrollDom.getBoundingClientRect();
                const scrollTop = scrollDom.scrollTop + rect.top - scrollRect.top;
                scrollRef.current.scrollTop(scrollTop, 'smooth');
                _isScrollingRef.current = true;
                clearTimeout(_scrollingTimerRef.current);
                _scrollingTimerRef.current = setTimeout(() => {
                    _isScrollingRef.current = false;
                }, 1000);
            }
        },
        [categoryRef, scrollRef],
    );

    useEffect(() => {
        const index = styleList.findIndex(category => category.list.find(item => item.value === curStyle.value));
        _onTabChange(index - 1);
        //仅页面加载调用
    }, [_onTabChange, curStyle, showSideModel, styleList]);

    useEffect(() => {
        if (showSideModel && tabRef.current) {
            tabRef.current.updateArrowState();
        }
    }, [showSideModel]);

    return (
        <>
            <div className={styles.styles_box} id={id}>
                <div className={styles.styles_title}>{FJLocalStore._('style')}</div>
                <div className={styles.styles_btu} onClick={handleClick} onMouseDown={handleOnMouseDown}>
                    {curStyle.value !== '' && (
                        <div className={styles.styles_img_box}>
                            <img src={curStyle.previewImg} loading='lazy' />
                        </div>
                    )}
                    <div className={styles.styles_name}>{FJLocalStore._(curStyle.name)}</div>
                    <ArrowIcon className={styles.arrow_icon} />
                </div>
            </div>

            <FJSideModel
                position={{ top: 125, left: 478 }}
                active={showSideModel}
                className={styles.styles_side_model}
                onClose={() => setShowSideModel(false)}
            >
                <div className={styles.styles_title}>{FJLocalStore._('style')}</div>

                <FJHorizontalScrollTab
                    dataList={categoryList}
                    selectedIndex={selectStyleCategory}
                    space={8}
                    className={styles.style_tab_box}
                    onTabChange={_onTabChange}
                    itemClassName={styles.style_tab_item}
                    lineClassName={styles.line}
                    gradationClassName={styles.gradation}
                    textClassName={styles.style_tab_text}
                    gradationContentClassName={styles.gradation_content}
                    gradationActiveClassName={styles.gradation_active}
                    isGradationBorder={true}
                    ref={tabRef}
                />

                <FJVerticalScroller className={styles.scroll} ref={scrollRef}>
                    {styleList.map((category, index) => {
                        return (
                            <div key={category.categoryName} className={styles.category_box}>
                                <div className={styles.category_title} ref={ref => (categoryRef.current[index] = ref)}>
                                    {FJLocalStore._(category.categoryName)}
                                </div>
                                <div className={styles.category_list_box}>
                                    {category.list.map(item => (
                                        <FJHoverBoardGradation
                                            key={item.value}
                                            className={classNames(styles.category_list_item, {
                                                [styles.none_style_box]: item.value === '',
                                            })}
                                            contentClassName={classNames(
                                                item.value === '' ? styles.category_list_item_content : '',
                                            )}
                                            isShowInBorder={item.value !== ''}
                                            active={item.name === curStyle.name}
                                            onClick={() => handleChangeStyle(item)}
                                        >
                                            {item.value === '' ? (
                                                <img src={item.previewImg} className={styles.none_style_image} />
                                            ) : (
                                                <>
                                                    <img src={item.previewImg} />
                                                    <div className={styles.category_list_item_name_box}>
                                                        <span className={styles.category_list_item_name}>
                                                            {FJLocalStore._(item.name)}
                                                        </span>
                                                    </div>
                                                </>
                                            )}
                                        </FJHoverBoardGradation>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </FJVerticalScroller>
            </FJSideModel>
        </>
    );
};

FJTextToImageStyles.propTypes = {
    curStyle: PropTypes.object,
    changeStyle: PropTypes.func,
    styleList: PropTypes.array,
};

export default FJTextToImageStyles;
